import {Colonia} from "../../entities/catalogos/Colonia";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";
import {AreaServicio} from "../../entities/catalogos/AreaServicio";
import {Sucursal} from "../../entities/catalogos/Sucursal";
import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import { CruceInternacional } from "../../entities/catalogos/CruceInternacional";
import { IIntraUSA } from "../../components/origenDestino/IntraUSA";

export const SET_RECOLECCION_ORIGEN = 'SET_RECOLECCION_ORIGEN';
export const SET_RECOLECCION_DESTINO = 'SETRECOLECCION__DESTINO';
export const LOAD_SUCURSALES_SUCCESS = 'LOAD_SUCURSALES_SUCCESS';

export interface IRecoleccion{
    paisId: number
    codigoPostal: string
    direccion: string
    colonia?: Colonia
    areaServicio?: AreaServicio
    sucursal?: Sucursal
    tipoRecoleccionId?: number
    fechaRecoleccion?: Date
    fechaCita?: Date
    aceptaCita: boolean
    sinAreaServicio: boolean
    esForanea: boolean
    completado: boolean
    contacto?: any
    distribuidor?:any
    serviciosAdicionales?: ServicioAdicional[]
    EsFueraHorario?: boolean
    horaFHDe?: string
    horaFHHasta?: string,
    tieneCruceFronterizo?: boolean,
    recalcularServicios?: boolean,
    documentos?: any,
    fechaCitaCedis?: Date,
    EsCitaRadCedis?:boolean,
    EsCitaEadCedis?:boolean
    esHomeDelivery?: boolean,
    tipoDeRecoleccionDestino?: any
    esComercioExterior?: boolean
    esServicioInternacional?: boolean,
    eliminaRetornoDocumentos?:boolean,
    tipoDeRecoleccionOrigen?: any
}

interface ISetRecoleccionOrigen {
    type: typeof SET_RECOLECCION_ORIGEN
    recoleccion: IRecoleccion
}

interface ISetRecoleccionDestino {
    type: typeof SET_RECOLECCION_DESTINO
    recoleccion: IRecoleccion
}

interface ILoadSucursales {
    type: typeof LOAD_SUCURSALES_SUCCESS
    sucursales: Sucursal[]
}

export type RecoleccionActionTypes = ISetRecoleccionOrigen | ISetRecoleccionDestino | ILoadSucursales
